module.exports = __webpack_public_path__ + "19b7a0adfdd4f808b53af7e2ce2ad4e5.woff2";